import { render, staticRenderFns } from "./reportModerated.vue?vue&type=template&id=7cc4da3f&scoped=true"
import script from "./reportModerated.vue?vue&type=script&lang=js"
export * from "./reportModerated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc4da3f",
  null
  
)

export default component.exports